import { render, staticRenderFns } from "./workDrawer.vue?vue&type=template&id=a4ef0164&"
import script from "./workDrawer.vue?vue&type=script&lang=js&"
export * from "./workDrawer.vue?vue&type=script&lang=js&"
import style0 from "./workDrawer.vue?vue&type=style&index=0&id=a4ef0164&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports